module.exports = __webpack_public_path__ + "cf29854de6f403709c54dc920f2039d2.png";